// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3FPJQ","emails":"CreateEditClinics_emails__11Lmz","emailTagLabel":"CreateEditClinics_emailTagLabel__15vID"};